import { fetchPost } from '../lib/_fetchPost.js';
import { masonry } from '../lib/_masonry.js';
import { loc } from './_location.js';
import { viewTransition } from '../page/_viewTransition.js';

import { load } from './_load.js';
import { template } from './_template.js';
import { pageStatus } from '../page/_page_tools.js';
import { reActive, filterNav } from '../page/_pushstate.js';


let hasFilterPage = ["works", "magazine", "member"];

export let loadPost = {
	isLoading: true,
	info: {},
	isPageCategory: "",
	allData:[],
	filteredData: [],
	wedCafe: {},
	wedCafeAll: [],
	reset: function(){ //scroll.jsから呼び出し
		console.log("reset load Post");
		pageStatus.reset().then( ()=> {
			filterNav.init();
		});
	},
	init: function(){
		return new Promise( (resolve, reject) => {
			let $body 		= document.querySelector("body");
			//console.log(pageStatus);
			//$body.classList.add("loading");
			
			loadPost.isPageCategory = $body.getAttribute("data-page-category");
			//console.log("loadPost init:", loadPost.isPageCategory);
			fetchPost.get( loadPost.isPageCategory ).then( (data) => {
				loadPost.allData = data;
				//console.log("init呼ばれた回数確認 / allData length:", data.length);
				//console.log(data);
				//console.log("loadPosts:", loadPost.allData)
				if( pageStatus.category != "" ){
					//カテゴリがあればフィルターデータにフィルターして追加
					let filtered = fetchPost.filterByCategory( loadPost.allData, pageStatus.category );
					loadPost.filteredData = filtered;
				}else if( pageStatus.tag != "" ){
					let filtered = fetchPost.filterByTag( loadPost.allData, pageStatus.tag );
					loadPost.filteredData = filtered;
					//console.log("filteredData length:", loadPost.filteredData.length); // ← これを確認
				}else{
					//カテゴリがない場合はフィルターデータに全件追加
					loadPost.filteredData = data;
				}
				
				let $perPage 			= document.querySelector("[data-per-page]");
				if($perPage){
					pageStatus.count 		= 0;
					pageStatus.totalCount 	= loadPost.filteredData.length;
					pageStatus.perPage 		= parseInt( $perPage.getAttribute("data-per-page") );
					pageStatus.max 			= Math.ceil( pageStatus.totalCount/pageStatus.perPage );
				}
				
				//Magazineの場合は水曜食堂のデータを取得
				if( loadPost.isPageCategory === "magazine"){
					
					fetchPost.getWedCafe().then( (data) => {
						loadPost.wedcafe = data.wedcafe;
						fetchPost.getWeCafeAllPost().then( (wedcafeData) => {
							loadPost.wedCafeAll = wedcafeData;
							//console.log("水曜食堂の一覧: ", loadPost.wedCafeAll);
							loadPost.addMagazine();
							resolve();
						});
					});
				}else if(loadPost.isPageCategory === "works"){
					loadPost.addWorks();
					resolve();
				}else if( loadPost.isPageCategory === "news" ){
					loadPost.addNews();
					resolve();
				}else if( loadPost.isPageCategory === "people" ){
					loadPost.afterAddedCommon();
					//console.log("is PEOPLE");
					resolve();
				}
			});
		});
	},
	nextPage: function(){
		//スクロールによって呼び出される関数
		//console.log("next Page >");
		//console.log("load next Page", loadPost.isLoading);
		if( !loadPost.isLoading ){
			loadPost.isLoading = true;
			pageStatus.count++;
			//console.log("loadnext page 2", pageStatus.count, pageStatus.max);
			if( pageStatus.count >= pageStatus.max){
				pageStatus.count = pageStatus.max;
			}else{
				if( loadPost.isPageCategory === "works" ){
					loadPost.addWorks();
				}else if( loadPost.isPageCategory === "magazine"){
					loadPost.addMagazine();
				}else if( loadPost.isPageCategory === "news"){
					loadPost.addNews();
				}
			}
		}
	},
	addWorks: function(){
		let data = fetchPost.getDataByPage(loadPost.filteredData, pageStatus.count, pageStatus.perPage);
		//console.log(data);
		let HTML = "";
		let $target;
		$target = document.querySelector(".c-list-works_summaries ul");
		let $body = document.querySelector("body");
		if( $body.classList.contains("is_tag") ){
			$body.classList.remove("is_tag");
		}
		for(let i = 0; i < data.length; i++){
			let d = data[i];
			HTML += template.worksSummary(d);
		}
		//ページが0件目の場合は全てのPostを削除してDOMを上書き
		if( pageStatus.count === 0){
			$target.innerHTML = HTML;
		}else{
			if( $target ){
				$target.insertAdjacentHTML('beforeend', HTML);
			}
		}
		setTimeout(function(){
			loadPost.afterAddedCommon();
		}, 100);
	},
	addMagazine: function(){
		const WEDCAFENUM = 3;
		//getParam
		let params 		= location.search.substring(1);
		let paramArry	= params.split("&");
		let locParams = [];
		for (let i = 0; paramArry[i]; i++) {
			let kv = paramArry[i].split("=");
			locParams[kv[0]] = kv[1];
		}
		
		let isWedCafe = false; //水曜食堂で絞り込まれているかチェック
		let $body = document.querySelector("body");
		if( pageStatus.tag != "" ){
			if( !$body.classList.contains("is_tag") ){
				$body.classList.add("is_tag");
			}
		}else{
			if( $body.classList.contains("is_tag") ){
				$body.classList.remove("is_tag");
			}
		}
		if( locParams.tag === "wednesday_kitchen" ){
			isWedCafe = true;
		}
		if( pageStatus.tag === "wednesday_kitchen" ){
			isWedCafe = true;
		}
		
		//console.log("水曜食堂? =>", isWedCafe);
		let postData = fetchPost.getDataByPage(loadPost.filteredData, pageStatus.count, pageStatus.perPage);
		//console.log(postData);
		//console.log("add magazine: isWedCafe:", pageStatus.tag, isWedCafe, postData)
		let data = [];
		//console.log(postData, loadPost.wedcafe);
		
		if( !isWedCafe ){
			/* 水曜食堂のタグがついているものは出力しない */
			/*
			data = postData.filter(post => 
				// タグがついていない場合 (null または undefined)
				!Array.isArray(post.tags) ||
				// タグがある場合、その中に "wednesday_kitchen" が含まれていない
				!post.tags.some(tag => tag.slug === "wednesday_kitchen")
			);
			//console.log(data);
			*/
			
			postData.forEach( ( post ) => {
				//console.log(post);
				if( loadPost.wedcafe[0].id != post.id ){
					const hasWedKitchen = post.tags?.some(tag => tag.slug === 'wednesday_kitchen');
					if (!hasWedKitchen) {
					  data.push(post);
					}
				}
			});
		}else{
			//data = postData;
			
			data = loadPost.wedCafeAll;
			
			//currentPosts = data;
			//console.log("水曜食堂用データ", data);
		}
		//console.log("magazineData:", data);
		if( pageStatus.tag != "" ){
			//console.log(loadPost.allData)
			let firstPost = data[0];
			if(firstPost){
				let tags = firstPost.tags;
				if(tags.length > 0){
					tags.forEach( (t) => {
						if( t.slug === pageStatus.tag){
							//console.log(t);
							document.querySelector(".c-ttl_filter_tag p").innerHTML = "#" + t.name;
						}
					});
				}else{
					document.querySelector(".c-ttl_filter_tag p").innerHTML = "#水曜食堂"
				}
			}
		}
		let HTML = "";
		let $target;
		$target = document.querySelector(".c-list-magazine_summaries ul");
		for(let i = 0; i < data.length; i++){
			let d = data[i];
			//2026.05
			if( isWedCafe ){
				/* 1件目のものは、今週のものなので、画像がない。常に献立を表示。 2件目以降をリストとして出力する*/
				if( i === 0 ){
					HTML += template.wedCafe(loadPost.wedcafe, 2);
				}else{
					if( i > 0 ){
						HTML += template.magazineSummary(d, pageStatus.tag, i);
					}
				}
			}else{
				let isTag = document.querySelector("body").classList.contains("is_tag");
				if( i === 2 && pageStatus.count === 0 && !isTag ){
					HTML += template.wedCafe(loadPost.wedcafe, 1);
				}
				HTML += template.magazineSummary(d, "");
			}
		}
		//ページが0件目の場合は全てのPostを削除してDOMを上書き
		if( pageStatus.count === 0){
			$target.innerHTML = HTML;
		}else{
			if( $target ){
				$target.insertAdjacentHTML('beforeend', HTML);
			}
		}
		//console.log("add magazine")
		masonry.resize($target, isWedCafe);
		setTimeout(function(){
			masonry.resize($target, isWedCafe);
			loadPost.afterAddedCommon();
			let lists = $target.querySelectorAll("li.disable");
			lists.forEach(function( $l ){
				$l.classList.remove("disable");
			});
		}, 300);
		
		let resizeFlag;
		let resizeTimer = null;
		var resizeCallback = function() {
			masonry.resize($target, isWedCafe);
			resizeTimer = null;
		};
		window.removeEventListener("resize", resizeList, false);
		window.addEventListener("resize", resizeList, false);
		
		function resizeList(){
			if(resizeTimer) { clearTimeout(resizeTimer);}
			resizeTimer = setTimeout(resizeCallback, 300);
		}
	},
	addNews: function(){
		//console.log(loadPost.filteredData, pageStatus.count, pageStatus.perPage);
		let data = fetchPost.getDataByPage(loadPost.filteredData, pageStatus.count, pageStatus.perPage);
		//console.log(data);
		let HTML = "";
		let $target;
		$target = document.querySelector(".c-list-news_summaries ul");
		let $body = document.querySelector("body");
		if( $body.classList.contains("is_tag") ){
			$body.classList.remove("is_tag");
		}
		for(let i = 0; i < data.length; i++){
			let d = data[i];
			//console.log(d);
			HTML += template.newsSummary(d);
		}
		//ページが0件目の場合は全てのPostを削除してDOMを上書き
		if( pageStatus.count === 0){
			$target.innerHTML = HTML;
		}else{
			if( $target ){
				$target.insertAdjacentHTML('beforeend', HTML);
			}
		}
		setTimeout(function(){
			loadPost.afterAddedCommon();
		}, 100);
	},
	afterAddedCommon: function(){
		let $body = document.querySelector("body");
		//loadPost.isLoading = false;
		//console.log("load after Add common", loadPost.isLoading);
		setTimeout(function(){
			if( $body.classList.contains("loading") ){
				$body.classList.remove("loading");
			}
			//category絞り込み時
			if( $body.classList.contains("change_category") ){
				$body.classList.remove("change_category");
			}
			if( $body.classList.contains("change_tag") ){
				$body.classList.remove("change_tag");
			}
			reActive.nav();
			loadPost.isLoading = false;
		}, 300);
	}
}
/* pushstateからloadPostのinitをかけられるように */
export let loadFromExternal = {
	init: function(){
		return new Promise( (resolve, reject) => {
			loadPost.isLoading = false;
			loadPost.init().then( ()=> {
				resolve();
			});
		})
	},
	deActiveLoading: function(){
		loadPost.isLoading = false;
	}
}